<div *ngIf="student" class="d-flex flex-column justify-content-start align-items-start h-100 w-100">

    <div class="bg-grey-lighter-color w-100 mb-3 p-2">
        <span class="fs-5 fw-bolder">Datos del participante</span>
    </div>

    <!-- NIF/NIE -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">NIF/NIE</span>
        <input type="text" pInputText class="w-100" [ngModel]="getDNI()" readonly="true"/>
    </div>

    <!-- Nombre -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Nombre</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.name" readonly="true"/>
    </div>

    <!-- Apellidos -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Apellidos</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.surname" readonly="true"/>
    </div>

    <!-- Fecha de nacimiento -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Fecha de nacimiento</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.birthDate | date:'dd/MM/yyyy'" readonly="true"/>
    </div>

    <!-- Género -->
    <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-2">
        <span class="text-primary-color fw-bolder">Género</span>
        <input type="text" pInputText class="w-100" [ngModel]="student.genderName" readonly="true"/>
    </div>

</div>
